// extracted by mini-css-extract-plugin
export default {"button":"Login_button__BIYaJ","space":"Login_space__+l7Fc"};